(function () {
    'use strict';

    // @ngInject
    Services.iterable = function iterable($window, Gon, ThirdPartyLoaderService) {
        // since iterable's snippet uses a plain array to push commands until their sdk loads, we don't need to return a promise
        ThirdPartyLoaderService.loadUrlPromise('https://js.iterable.com/analytics.js', function() {
            // iterable's snippet allows to use a plain array to push commands to until their sdk loads.
            // once their SDK loads, it's an object that contains function
            // so..... the "sdk loaded" check is whether the _iaq variable exists and it's NOT an array
            return $window._iaq && !Array.isArray($window._iaq);
        });

        $window._iaq = $window._iaq || [];
        $window._iaq.push(['account', Gon.iterable_api_key]);

        var wrapper = {
            identifyUser: function identifyUser(email, data) {
                $window._iaq.push(['identify', email, data]);
            },

            trackEvent: function trackEvent(eventName, data) {
                $window._iaq.push(['track', eventName, data]);
            }
        };

        return wrapper;
    };

}());